var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-text-field", {
    ref: "textfield",
    staticClass: "service-credentials-textfield",
    attrs: { label: _vm.title, value: _vm.value, readonly: "", box: "" },
    on: {
      click: function ($event) {
        return _vm.copyText()
      },
    },
    scopedSlots: _vm._u([
      {
        key: "append",
        fn: function () {
          return [
            _c("v-scroll-x-transition", [
              _vm.isCopied
                ? _c(
                    "div",
                    [
                      _c("v-icon", { attrs: { color: "green" } }, [
                        _vm._v("done"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-top": "6px",
                            display: "inline-block",
                          },
                        },
                        [_vm._v("\n          Copied!\n        ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }